<template>
	<div>
		<v-row :class="['flex-nowrap', ...inputClassNames]" no-gutters>
			<v-text-field
				:label="required ? `${label}（必須）` : label"
				:rules="required ? [rules.required] : []"
				class="clickable"
				v-model="associationValue"
				readonly
				dense
				outlined
				@mousedown.stop="getAssociationData(pagination.current)"
			/>
			<v-btn v-if="associationValue" class="ml-2" icon @click="cancelTarget"
				><v-icon> mdi-close-circle-outline</v-icon></v-btn
			>
		</v-row>

		<v-dialog
			v-model="dialog"
			max-width="800px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<v-card ref="associationSelectDialog">
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white">データ選択</v-app-bar-title>
				</v-app-bar>
				<v-card-text class="pa-2 table-container">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="items"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="setTarget(item)" class="clickable">
								<td v-for="(column, i) in columns" :key="i">
									{{ tdValue(column, item) }}
								</td>
							</tr></template
						>
					</v-data-table>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</v-card-text>
				<v-card-actions>
					<v-row class="ma-0 pa-0" justify="end">
						<v-spacer></v-spacer>
						<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import rules from "../../helper/rules"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import PaginationModule from "./PaginationModule.vue"

export default {
	components: {
		PaginationModule,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			type: null,
			required: true,
		},
		association_value: {
			type: String,
			required: false,
			default: "",
		},
		required: {
			type: Boolean,
			default: false,
		},
		// ポリモーフィックで使用しない場合、IDのみを返す
		onlyId: {
			type: Boolean,
			default: false,
		},
		associationName: {
			type: String,
			required: false,
		},
		type: {
			type: String,
			required: false,
		},
		id: {
			type: String || Number,
			required: false,
		},
		urlType: {
			type: null,
			required: false,
			default: "common",
		},
		column_id: {
			type: Number,
			required: false,
		},
		inputClassNames: {
			type: Array,
			required: false,
			default: () => ['mt-4'],
		},
	},
	data() {
		return {
			dialog: false,
			items: [],
			columns: [],
			headers: [],
			ledgerAssociationName: null,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			rules: rules,
		}
	},
	methods: {
		getAssociationData(i) {
			const headers = authenticate.setHeader()
			let url = ""
			let params = {}
			if (this.urlType == "ledger") {
				url = "/erp/v1/ledgers/targets/"
				params = {
					column_id: this.column_id,
					page: i,
				}
			} else {
				url = "/erp/v1/targets/"
				params = {
					target_type: this.associationName,
					page: i,
				}
			}
			axios
				.get(url, {
					headers,
					params,
				})
				.then((res) => {
					this.items = res.data.target_data
					this.columns = res.data.columns
					this.pagination = res.data.pagination
					this.ledgerAssociationName = res.data.association_name
					this.headers = res.data.columns.map((column) => {
						let width = column.width ? column.width : 200
						return { text: column.name, value: column.id, width }
					})
					this.dialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			const element = this.$refs.synchronizationDialog.$el.parentElement
			element.scrollTo({
				top: 0,
				behavior: "smooth",
			})
			this.getAssociationData(i)
		},
		tdValue(column, item) {
			const value_array = column.id.split(".")
			let value = item
			value_array.forEach((key) => {
				value = value[key]
				if (value == null || value == undefined) return null
			})
			switch (column.data_type) {
				case "date":
					return moment(value).format("YYYY/MM/DD")
				case "datetime":
					return moment(value).format("YYYY/MM/DD HH:mm:ss")
				case "time":
					return moment(value).format("HH:mm")
				default:
					return value
			}
		},
		setTarget(item) {
			const mainColumn = this.columns.find((c) => c.main_column)
			this.associationValue = this.tdValue(mainColumn, item)
			if (this.urlType == "ledger") {
				this.metaValue[this.type] = this.ledgerAssociationName
				this.metaValue[this.id] = item.id
			} else if (this.onlyId) {
				this.metaValue = item.id
			} else {
				this.metaValue[this.type] = this.associationName
				this.metaValue[this.id] = item.id
			}
			this.dialog = false
		},
		cancelTarget() {
			this.associationValue = ""
			if (this.onlyId) {
				this.metaValue = null
			} else {
				this.metaValue[this.type] = null
				this.metaValue[this.id] = null
			}
		},
	},
	computed: {
		metaValue: {
			get() {
				return this.value
			},
			set(newVal) {
				return this.$emit("update:value", newVal)
			},
		},
		associationValue: {
			get() {
				return this.association_value
			},
			set(newVal) {
				return this.$emit("update:association_value", newVal)
			},
		},
	},
}
</script>